'use client';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import { StepHeaderContent, StepTitle, StepDescription } from './styles';

export const ScreeningStepResultHeader = ({ title, description, image }) => (
  <StepHeaderContent>
    <ResponsiveImage
      src={image.src}
      alt={image.alt}
      width={image.width}
      height={image.height}
    />
    <StepTitle>{title}</StepTitle>
    <StepDescription>{description}</StepDescription>
  </StepHeaderContent>
);

ScreeningStepResultHeader.displayName = 'ScreeningStepResultHeader';
ScreeningStepResultHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.object,
};
